<div class="pcheck-card">
  <div class="pcheck-card__header">
    <i class="pi pi-user-plus" aria-hidden="true"></i>
    <span>Add Participants — {{ details.executive }}</span>
  </div>
  <div class="pcheck-card__body">

    @if (showTzPicker) {
      <div class="pcheck-card__tz">
        <span class="pcheck-card__tz-label">Times in</span>
        <app-timezone-select [value]="displayTz()" [compact]="true" (valueChange)="onTimezoneChange($event)"></app-timezone-select>
      </div>
    }

    <app-meeting-detail-table
      [accountName]="details.account_name"
      [executive]="details.executive"
      [subject]="details.subject"
      [startTime]="details.start_time"
      [displayTimezone]="displayTz()"
      [attendeeEmail]="details.attendee_email"
      [alreadyInvited]="details.all_attendee_emails?.length ? details.all_attendee_emails : details.additional_guests">
    </app-meeting-detail-table>

    @if (confirmed) {
      <!-- ── Confirmed ── -->
      <div class="pcheck-card__confirmed">
        <i class="pi pi-check-circle" aria-hidden="true"></i> Participants Added
      </div>
      @if (addedParticipants?.length) {
        <div class="add-participants-card__added">
          <span class="add-participants-card__added-label">Newly added:</span>
          @for (email of addedParticipants; track email; let last = $last) {
            <span class="add-participants-card__added-email">{{ email }}{{ last ? '' : ', ' }}</span>
          }
        </div>
      }

    } @else if (!dismissed) {

      @if (!started()) {
        <!-- ── Default: prompt to start ── -->
        <div class="pcheck-card__warning pcheck-card__warning--info">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          New participants are added directly to the existing Outlook invite.
          Existing attendees are unaffected and will not receive a new invite.
        </div>
        <div class="pcheck-card__actions">
          <button type="button" class="pcheck-btn pcheck-btn--neutral" (click)="onDismiss()">
            <i class="pi pi-times" aria-hidden="true"></i> Cancel
          </button>
          <button type="button" class="pcheck-btn pcheck-btn--link" (click)="onStart()">
            <i class="pi pi-user-plus" aria-hidden="true"></i> Add Participants
          </button>
        </div>

      } @else if (contacts === undefined) {
        <!-- ── Loading contacts ── -->
        <div class="add-participants-card__loading">
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Loading contacts…
        </div>
        <div class="pcheck-card__actions">
          <button type="button" class="pcheck-btn pcheck-btn--neutral" (click)="onDismiss()">
            <i class="pi pi-times" aria-hidden="true"></i> Cancel
          </button>
        </div>

      } @else {
        <!-- ── Guest wizard ── -->
        <app-guest-wizard
          [contacts]="contacts"
          mode="add-participants"
          (guestsConfirmed)="onGuestsConfirmed($event)"
          (cancelled)="onDismiss()">
        </app-guest-wizard>
      }

    }

  </div>
</div>
